/* Supergolfers shop pages - swipe the product gallery (touch, mouse drag, arrow keys) */
(function(){
  function init(){
    var stage=document.getElementById('sgp-stage'),box=document.getElementById('sgp-tilt'),main=document.getElementById('sgp-main');
    if(!stage||!box||stage.dataset.swipe)return;
    var thumbs=[].slice.call(document.querySelectorAll('.sgp-thumb'));
    if(thumbs.length<2)return;
    stage.dataset.swipe='1';
    var cur=function(){for(var i=0;i<thumbs.length;i++){if(thumbs[i].getAttribute('aria-current')==='true')return i}return 0};
    var go=function(dir){
      var t=thumbs[(cur()+dir+thumbs.length)%thumbs.length];
      t.click();
      if(main){main.classList.remove('is-swap','sgp-in-next','sgp-in-prev');void main.offsetWidth;main.classList.add(dir>0?'sgp-in-next':'sgp-in-prev')}
      var row=t.parentNode;row.scrollTo({left:t.offsetLeft-(row.clientWidth-t.clientWidth)/2,behavior:'smooth'});
    };
    var drag=function(dx){box.style.transition='none';box.style.transform='translateX('+dx+'px)'};
    var release=function(){box.style.transition='transform .3s ease';box.style.transform=''};
    /* touch */
    var x0=null,y0=null,lock=null,dx=0;
    stage.addEventListener('touchstart',function(e){if(e.touches.length>1)return;x0=e.touches[0].clientX;y0=e.touches[0].clientY;lock=null;dx=0},{passive:true});
    stage.addEventListener('touchmove',function(e){
      if(x0===null)return;var p=e.touches[0],mx=p.clientX-x0,my=p.clientY-y0;
      if(lock===null&&(Math.abs(mx)>8||Math.abs(my)>8))lock=Math.abs(mx)>Math.abs(my);
      if(lock){e.preventDefault();dx=mx;drag(mx*.6)}
    },{passive:false});
    var end=function(){if(x0===null)return;release();if(lock&&Math.abs(dx)>40)go(dx<0?1:-1);x0=null;lock=null;dx=0};
    stage.addEventListener('touchend',end);stage.addEventListener('touchcancel',end);
    /* mouse drag */
    var mx0=null,mdx=0;
    stage.addEventListener('pointerdown',function(e){if(e.pointerType!=='mouse'||e.button!==0)return;mx0=e.clientX;mdx=0;e.preventDefault()});
    window.addEventListener('pointermove',function(e){if(mx0===null)return;mdx=e.clientX-mx0;if(Math.abs(mdx)>6){stage.classList.add('is-dragging');drag(mdx*.6)}});
    window.addEventListener('pointerup',function(){if(mx0===null)return;stage.classList.remove('is-dragging');release();if(Math.abs(mdx)>50)go(mdx<0?1:-1);mx0=null;mdx=0});
    /* keyboard */
    stage.tabIndex=0;stage.setAttribute('aria-roledescription','carousel');
    stage.addEventListener('keydown',function(e){if(e.key==='ArrowRight'){e.preventDefault();go(1)}else if(e.key==='ArrowLeft'){e.preventDefault();go(-1)}});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
